"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineMissingRoles = void 0;
const PersonRole_1 = require("../enm/PersonRole");
const Country_1 = require("../enm/Country");
const euCountries = [Country_1.Country.AU, Country_1.Country.BE, Country_1.Country.BG, Country_1.Country.HR, Country_1.Country.CY, Country_1.Country.CZ, Country_1.Country.DE, Country_1.Country.EE, Country_1.Country.FI, Country_1.Country.FR, Country_1.Country.DE, Country_1.Country.GR, Country_1.Country.HU,
    Country_1.Country.IE, Country_1.Country.IT, Country_1.Country.LV, Country_1.Country.LT, Country_1.Country.LU, Country_1.Country.MT, Country_1.Country.NL, Country_1.Country.PL, Country_1.Country.PT, Country_1.Country.RO, Country_1.Country.SK, Country_1.Country.SI, Country_1.Country.ES, Country_1.Country.SE];
const determineMissingRoles = (payload) => {
    if (payload.contract_onboarding_type === 'MOR_ONBOARDING_ENTITY') {
        return [PersonRole_1.PersonRole.ULTIMATE_BENEFICIAL_OWNER, PersonRole_1.PersonRole.LEGAL_REPRESENTATIVE];
    }
    if (!payload.business_information?.registered_address?.country || !euCountries.includes(payload.business_information.registered_address.country)) {
        return [];
    }
    const personRoles = payload.business_information?.persons?.flatMap?.(person => person.person_role) || [];
    if (payload.business_information?.is_registered === true) {
        const missingRoles = [];
        const oneOfRequiredRoles = [PersonRole_1.PersonRole.ULTIMATE_BENEFICIAL_OWNER, PersonRole_1.PersonRole.ALTERNATIVE_BENEFICIAL_OWNER];
        const missingOneOf = oneOfRequiredRoles.filter(function (requiredRole) {
            return !personRoles.includes(requiredRole);
        });
        if (missingOneOf.length === oneOfRequiredRoles.length) {
            missingRoles.push(...missingOneOf);
        }
        if (!personRoles.includes(PersonRole_1.PersonRole.LEGAL_REPRESENTATIVE)) {
            missingRoles.push(PersonRole_1.PersonRole.LEGAL_REPRESENTATIVE);
        }
        return missingRoles;
    }
    return [PersonRole_1.PersonRole.OWNER].filter(function (requiredRole) {
        return !personRoles.includes(requiredRole);
    });
};
exports.determineMissingRoles = determineMissingRoles;
